import React from 'react';
import { Modal, Table } from 'react-bootstrap';

const ValidationErrorModal = ({ show, onHide, errors = [] }) => {
    return (
        <Modal show={show} onHide={onHide} size="xl" centered>
            <Modal.Header closeButton className="bg-danger text-white">
                <Modal.Title>
                    <i className="bi bi-exclamation-triangle-fill me-2"></i>
                    File Validation Failed
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="p-0">
                <div className="alert alert-danger mb-0 rounded-0 border-0">
                    <div className="d-flex align-items-center">
                        <i className="bi bi-x-circle-fill me-2 fs-5"></i>
                        <div>
                            <strong>Upload failed due to validation errors.</strong>
                            <div className="small mt-1">Please fix the following issues in your Excel file and try uploading again.</div>
                        </div>
                    </div>
                </div>
                <div className="table-responsive" style={{ maxHeight: '500px' }}>
                    <Table striped bordered hover className="mb-0">
                        <thead className="table-dark sticky-top">
                            <tr>
                                  <th style={{ width: '12%' }}>Sheet</th>
                                <th style={{ width: '8%' }} className="text-center">Row</th>
                                 
                                <th style={{ width: '15%' }}>Column</th>
                                {/* <th style={{ width: '25%' }}>Description</th> */}
                             
                                <th style={{ width: '15%' }}>Current Value</th>
                                {/* <th style={{ width: '10%' }}>Type</th> */}
                                {/* <th style={{ width: '15%' }}>Field Name</th> */}
                            </tr>
                        </thead>
                        <tbody>
                            {errors.length === 0 ? (
                                <tr>
                                    <td colSpan="7" className="text-center text-muted py-4">
                                        <i className="bi bi-info-circle me-2"></i>
                                        No validation errors found
                                    </td>
                                </tr>
                            ) : (
                                errors.map((error, index) => (
                                    <tr key={index} className={index % 2 === 0 ? 'table-light' : ''}>
                                         <td>
                                            <span className="badge bg-info text-dark">{error.sheet}</span>
                                        </td>
                                        <td className="text-center">
                                            <span className="badge bg-danger rounded-pill">{error.row}</span>
                                        </td>
                                        <td>
                                            <code className="bg-light text-primary px-2 py-1 rounded">
                                                {error.column}
                                            </code>
                                        </td>
                                        {/* <td>
                                            <div className="fw-semibold">{error.description}</div>
                                        </td> */}
                                       
                                        <td>
                                            <div className="text-muted fst-italic">
                                                {error.value ? (
                                                    <span className="text-dark">"{error.value}"</span>
                                                ) : (
                                                    <span className="text-danger">(empty)</span>
                                                )}
                                            </div>
                                        </td>
                                        {/* <td>
                                            <span className={`badge ${
                                                error.type === 'required' ? 'bg-warning text-dark' :
                                                error.type === 'mixed' ? 'bg-secondary' :
                                                'bg-primary'
                                            }`}>
                                                {error.type}
                                            </span>
                                        </td> */}
                                        {/* <td>
                                            <small className="text-muted font-monospace">
                                                {error.name}
                                            </small>
                                        </td> */}
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </Table>
                </div>
            </Modal.Body>
            <Modal.Footer className="bg-light">
                <div className="d-flex justify-content-between w-100 align-items-center">
                    <div className="d-flex align-items-center text-muted">
                        <i className="bi bi-info-circle me-2"></i>
                        <span>
                            <strong>{errors.length}</strong> validation error{errors.length !== 1 ? 's' : ''} found
                            {errors.length > 0 && (
                                <span className="ms-2">
                                    • Rows affected: {[...new Set(errors.map(e => e.row))].length}
                                </span>
                            )}
                        </span>
                    </div>
                    <div className="d-flex gap-2">
                        {/* <button 
                            type="button" 
                            className="btn btn-outline-primary btn-sm"
                            onClick={() => {
                                // Create a simple text report for copying
                                const report = errors.map(e => 
                                    `Row ${e.row}, Column ${e.column}: ${e.description} - ${e.value || '(empty)'}`
                                ).join('\n');
                                navigator.clipboard.writeText(report);
                            }}
                        >
                            <i className="bi bi-clipboard me-1"></i>
                            Copy Errors
                        </button> */}
                        <button 
                            type="button" 
                            className="btn btn-secondary"
                            onClick={onHide}
                        >
                            <i className="bi bi-x-lg me-1"></i>
                            Close
                        </button>
                    </div>
                </div>
            </Modal.Footer>
        </Modal>
    );
};

export default ValidationErrorModal;
